import { Injectable } from '@angular/core';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { QueryParamsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  ClearErrors,
  SalesTeamActionTypes,
  SalesTeamsActionToggleLoading,
  SalesTeamsPageCancelled,
  SalesTeamsPageLoaded,
  SalesTeamsPageRequested,
  SalesTeamsPageToggleLoading,
  ThrowError,
} from '../_actions/sales-team.actions';
import { Router } from '@angular/router';
import { SalesTeamService } from '../_services/sales-team.service';

@Injectable()
export class SalesTeamEffects {
  showPageLoadingDistpatcher = new SalesTeamsPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new SalesTeamsPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new SalesTeamsActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new SalesTeamsActionToggleLoading({ isLoading: false });

  @Effect()
  loadSalesTeamsPage$ = this.actions$.pipe(
    ofType<SalesTeamsPageRequested>(SalesTeamActionTypes.SalesTeamsPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      const requestToServer = this.salesTeam.findSalesTeams(payload.page);
      const lastQuery = of(payload.page);
      return forkJoin([requestToServer, lastQuery]).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((response) => {
          if (response[0].error) {
            if (response[0].status === 401) {
              return response[0];
            } else if (response[0].status === 403) {
              this.router.navigateByUrl('/error/403');
              return new SalesTeamsPageCancelled();
            } else {
              this.store.dispatch(new ThrowError({ error: response[0].error }));
              return new SalesTeamsPageCancelled();
            }
          } else {
            const result = response[0];
            // tslint:disable-next-line:no-shadowed-variable
            const lastQuery: QueryParamsModel = response[1];
            this.store.dispatch(new ClearErrors());
            return new SalesTeamsPageLoaded({
              salesTeams: result.data,
              totalCount: result.count,
              page: lastQuery,
            });
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private salesTeam: SalesTeamService,
    private store: Store<AppState>,
    private router: Router,
  ) {}
}
